import React, { useState, useEffect } from "react";
import {
  AppBar,
  Box,
  Container,
  Toolbar,
  useTheme,
  useMediaQuery,
  Typography,
  Stack,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import OruclicksLogo from "../../Reusable/Logo";

const ResponsiveAppBar = ({ isDarkTheme }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  const navigate = useNavigate();

  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit',
      second: '2-digit',
      hour12: true 
    });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', { 
      weekday: 'short',
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  const handleLogoClick = () => {
    navigate("/dashboard");
  };

  return (
    <AppBar
      className="customize_header"
      position="fixed"
      elevation={0}
      sx={{
        background: isDarkTheme
          ? "linear-gradient(to right, #1a237e, #000000)"
          : "linear-gradient(to right, #ffffff, #f5f7fa)",
        color: isDarkTheme ? "#fff" : "#000",
        fontFamily: "DM Sans",
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
        borderRadius: "0 0 15px 15px",
        top: 0,
        left: 0,
        right: 0,
        width: "100%",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        transform: "translate3d(0, 0, 0)",
        WebkitTransform: "translate3d(0, 0, 0)",
        backfaceVisibility: "hidden",
        WebkitBackfaceVisibility: "hidden",
        transition: "none",
      }}
    >
      <Container>
        <Toolbar
          disableGutters
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "nowrap",
            py: isMobile ? 0.25 : 0.5,
          }}
        >
            {/* Logo - Left Side */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexShrink: 0,
              }}
            >
              <OruclicksLogo
                isDarkTheme={isDarkTheme}
                onClick={handleLogoClick}
                showText={true}
                size={isMobile ? "42px" : "45px"}
                textSize={isMobile ? "22px" : "24px"}
                iconOnly={false}
              />
            </Box>

            {/* Right Side - Date and Time */}
            <Stack 
              direction={isTablet ? "column" : "row"} 
              spacing={isTablet ? 0.5 : 2} 
              alignItems={isTablet ? "flex-end" : "center"}
            >
              {/* Date */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                <CalendarTodayIcon sx={{ fontSize: isMobile ? 16 : 18, color: isDarkTheme ? '#90caf9' : '#64748b' }} />
                <Typography 
                  variant="body2" 
                  sx={{ 
                    fontWeight: 600, 
                    color: isDarkTheme ? '#e0e0e0' : '#475569',
                    fontSize: isMobile ? '0.75rem' : '0.875rem'
                  }}
                >
                  {formatDate(currentTime)}
                </Typography>
              </Box>

              {/* Time */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                <AccessTimeIcon sx={{ fontSize: isMobile ? 16 : 18, color: isDarkTheme ? '#90caf9' : '#64748b' }} />
                <Typography 
                  variant="body2" 
                  sx={{ 
                    fontWeight: 600, 
                    color: isDarkTheme ? '#e0e0e0' : '#475569',
                    fontSize: isMobile ? '0.75rem' : '0.875rem',
                    fontFamily: 'monospace'
                  }}
                >
                  {formatTime(currentTime)}
                </Typography>
              </Box>
            </Stack>

          
          </Toolbar>
        </Container>
      </AppBar>
  );
};

export default ResponsiveAppBar;
